export default __webpack_public_path__ + "static/media/speakers__leena-mansour.080f8664.jpg";